import React, { useEffect } from "react";
import { formatDate } from "../../../Utils/utils";
import { 
  useGetCustomerContactByCustomerIdQuery, 
  useGetCustomerHistoryQuery, 
  useGetMedicalDetailsByCustomerIdQuery 
} from "../../../../../Service/PatientList";

const Details = ({ id }) => {
  // Fetch Customer History
  const { data: CustomerData } = useGetCustomerHistoryQuery(
    { Id: id },
    { refetchOnMountOrArgChange: true }
  );

  // Fetch Medical Details
  const { data: MedicalDetailsData } = useGetMedicalDetailsByCustomerIdQuery(
    { customerId: id },
    { refetchOnMountOrArgChange: true }
  );

  // Fetch Customer Contact
  const { data: CustomerContactData } = useGetCustomerContactByCustomerIdQuery(
    { customerId: id },
    { refetchOnMountOrArgChange: true }
  );

  // Extracting the first contact data if available
  const contact = CustomerContactData?.data?.[0] || {};

  // Extracting customer data
  const customer = CustomerData?.data || {};

  // Extracting the first medical detail data if available
  const medicalDetails = MedicalDetailsData?.data?.[0] || {};

  // Data for Rendering
  const data = [
    {
      name: customer?.customerName || "N/A",
      Sub: [
        { name: "Case ID", value: customer?.caseId || "N/A", icon: "remember_me" },
        { 
          name: "Date Of Birth", 
          value: customer?.dateOfBirth ? formatDate(customer.dateOfBirth) : "N/A", 
          icon: "cake" 
        },
        { name: "Sex", value: customer?.sex || "N/A", icon: "wc" },
        { name: "Referred by", value: customer?.referredBy || "N/A", icon: "step_over" },
        { name: "Occupation", value: customer?.occupation || "N/A", icon: "work" },
      ],
    },
    {
      name: "Contact Information",
      Sub: [
        { name: "Phone 1", value: contact?.phone1 || "N/A", icon: "call" },
        { name: "Phone 2", value: contact?.phone2 || "N/A", icon: "call" },
        { name: "Email", value: contact?.email1 || "N/A", icon: "mail" },
        { name: "Address", value: contact?.area || "N/A", icon: "home" },
        { name: "City", value: contact?.area || "N/A", icon: "location_city" },
      ],
    },
    {
      name: "Medical Details",
      Sub: [
        { name: "Blood Group", value: medicalDetails.bloodGroup || "N/A", icon: "water_drop" },
        { 
          name: "Height", 
          value: medicalDetails.height ? `${medicalDetails.height} cm` : "N/A", 
          icon: "height" 
        },
        { 
          name: "Weight", 
          value: medicalDetails.weight ? `${medicalDetails.weight} kg` : "N/A", 
          icon: "monitor_weight" 
        },
        { name: "Blood Pressure", value: medicalDetails.bp || "N/A", icon: "bloodtype" },
        { 
          name: "Temperature", 
          value: medicalDetails.temperature ? `${medicalDetails.temperature}` : "N/A", 
          icon: "thermostat" 
        },
        { 
          name: "SPO", 
          sub: "2", 
          value: medicalDetails.spo2 ? `${medicalDetails.spo2}` : "N/A", 
          icon: "globe_asia" 
        },
        { name: "Drug Allergy", value: medicalDetails.drugAllergy || "N/A", icon: "allergies" },
      ],
    },
  ];

  return (
    <div>
      {data.map((section) => (
        <div className="mt-3" key={section.name}>
          <div>
            <span className="fw-600 f-24">{section.name}</span>
          </div>
          <div>
            {section.Sub.map((item) => (
              <div
                className="d-flex gap-1 align-items-center mb-2 mt-4"
                key={item.name}
              >
                <span className="material-symbols-outlined">{item.icon}</span>
                <span className="f-14 fw-400" style={{ color: "#696969" }}>
                  {item.name}{" "}
                  {item.sub && (
                    <span>
                      <sub>{item.sub}</sub>
                    </span>
                  )}
                  :<span style={{ color: "#000000" }}> {item.value}</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Details;
